import React from 'react';

const Analytics = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Analytics</h1>
        <p className="text-muted-foreground">View insights and reports</p>
      </div>
      <div className="flex h-[400px] items-center justify-center rounded-lg border border-dashed border-border bg-card">
        <p className="text-muted-foreground">Analytics dashboard coming soon...</p>
      </div>
    </div>
  );
};

export default Analytics;

